/* Built In Imports */
/* Built In Imports */
import { Box, Text } from '@chakra-ui/react';
/* External Imports */
/* Internal Imports */
/* Components */
import config from '@config';

/* Services */
/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const AboutDeviSlide7 = ({ section }) => {
  // useEffect(() => {
  //   ScrollTrigger.create({
  //     trigger: '#mainSlider7',
  //     start: 'top',
  //     end: 'bottom',
  //     pin: '#slider7-content',
  //     markers: false,
  //   });
  // }, []);
  return (
    <Box id="mainSlider7">
      <Box
        id="slider7-content"
        background={`rgb(0 0 0 / 0%) url(${config.imgPath}/d/46272/1684474033-ib_secion5bg.jpeg) no-repeat center top`}
        bgSize="cover"
        className={styles.section7Bg}
        overflow="hidden"
      >
        <Box
          background={`rgb(0 0 0 / 0%) url(${config.imgPath}/d/46272/1684474730-ib_secion7bg.png) no-repeat center bottom`}
          backgroundSize={{ base: 'contain', md: '90%' }}
          height={{ base: '450px', md: '500px', xl: '100%' }}
          //filter={{ base: 'opacity(70%)', md: 'opacity(55%)' }}
          minH={{ base: '', md: '', lg: '42rem', xl: '' }}
        >
          <Box
            maxW="1200px"
            mx="auto"
            minH="100vh"
            display="flex"
            alignItems={{ base: 'start', sm: 'center' }}
            justifyContent="center"
          >
            <Box
              maxW="587px"
              p="2rem"
              borderRadius="100%"
              w="100%"
              textAlign="center"
              background="rgba(0, 0, 0, 0.4)"
              backdropFilter="blur(10px), saturate(10%)"
              boxShadow="0px -0px 50px #000"
            >
              <Text color="#fff" fontSize={{ base: '18px', lg: '24px' }}>
                {section?.sectionContent?.[0]?.text}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide7;
